/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectInstrumentV2} from '../api'

export const useMutationSelectInstrumentV2 = createReactQueryMutationHook('selectInstrumentV2', selectInstrumentV2)
